import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  EditIcon, StoryQuoteIcon, WhitePlusIcon,
} from 'pages/wholeme/icons/Icons';
import VideoPlayer from '../../../../components/VideoPlayer';
import TruncateText from '../../../../components/TruncateText';
import appColors from '../../../../common/app_colors';

const WholeMeStoryScrollItem = ({
  item, editable, onClickCallBack, errorCallBack, openGenericModal, showUploadButton,
}) => {
  const isUploadButton = showUploadButton && editable;
  const type = showUploadButton ? 'upload' : (item?.media_type || 'text');
  const video = item?.media_url ? [{ uri: item?.media_url }] : null;
  const { text, buttons } = appColors;

  const handleClick = (e) => {
    e.stopPropagation();
    if (isUploadButton) {
      openGenericModal();
    } else if (onClickCallBack && editable) {
      onClickCallBack(item);
    }
  };

  const handleGenericaModalOpen = (e) => {
    e.stopPropagation();
    openGenericModal();
  };

  return (
    <Box
      key={item?.id}
      sx={{
        maxWidth: '285px',
        minWidth: '285px',
        minHeight: '245px',
        maxHeight: '285px',
        backgroundColor: '#ffff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        borderRadius: '8px',
        cursor: 'pointer',
        overflow: 'hidden',
        position: 'relative', // Make this Box relative to position icons within it
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'left',
          position: 'relative', // Ensure positioning context
          overflow: 'hidden',
          pl: editable ? '20px' : '25px',
        }}
        onClick={(e) => handleClick(e, item)}
      >
        {editable && (
        <Box sx={{ pt: '15px', px: '5px', position: 'relative' }}>
          <EditIcon />
        </Box>
        )}
        <Typography
          sx={{
            color: text.blackText,
            textAlign: 'left',
            fontSize: '20px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontWeight: '500',
            maxWidth: '86%',
            pt: editable ? '10px' : '15px',
          }}
        >
          {item?.title}
        </Typography>
      </Box>
      <Box
        sx={{
          width: '100%',
          minHeight: '80%',
          flex: '1 1 auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: type.includes('video') ? 'flex-end' : 'flex-start',
          gap: type.includes('video') ? '10px' : null,
        }}
      >
        {type.includes('video') && (
        <>
          {item?.description && (
            <Box
              sx={{
                px: '25px',
                overflowY: 'auto',
                overflowX: 'hidden',
                fontSize: '14px',
                color: text.darkTaupe,
                flexGrow: 1,
                maxHeight: '50px',
              }}
            >
              {item?.description}
            </Box>
          )}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-end', // Align video player at the bottom
            }}
          >
            <VideoPlayer
              videos={video}
              errorCallback={errorCallBack}
              styleOverride={{
                maxWidth: '283px',
                maxHeight: (item?.description ? '180px' : '225px'),
              }}
            />
          </Box>
        </>
        )}
        {type === 'text' && (
        <Box
          sx={{
            color: text.darkTaupe,
            fontSize: '14px',
            px: '30px',
            overflowY: 'auto',
            maxHeight: '150px',
            pb: editable ? '0px' : '15px',
          }}
        >
          <TruncateText
            text={item?.description || ''}
            maxChars={185}
          />
        </Box>
        )}
        {isUploadButton && (
        <>
          {item?.description && (
            <Box
              sx={{
                pl: '25px',
                pb: '10px',
                flexGrow: 1,
              }}
            >
              <Typography
                sx={{
                  color: text.darkTaupe,
                  fontSize: '14px',
                }}
              >
                {item?.description}
              </Typography>
            </Box>
          )}
          <Box
            onClick={handleGenericaModalOpen}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: buttons.uploadStoryBackground,
              height: '200px',
              width: '100%',
              borderRadius: '8px',
            }}
          >
            <WhitePlusIcon />
          </Box>
        </>
        )}
        {/* Icons positioned at the bottom left of each item */}
        {type === 'text' && (
        <Box
          sx={{
            position: 'absolute',
            bottom: '10px',
            left: '15px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <StoryQuoteIcon />
        </Box>
        )}
      </Box>
    </Box>
  );
};

export default WholeMeStoryScrollItem;
